<template>
  <div>
    <show-credential-terminales-puntos-colombia ref="ShowCredentialTerminalesPuntosColombia" />
  </div>
</template>
<script>
  export default {
    components: {
      ShowCredentialTerminalesPuntosColombia: () => import('./components/ShowCredentialTerminalesPuntosColombia'),
    },
  }
</script>
